import {NgModule} from "@angular/core";
import {SpinnerComponent} from "./SpinnerComponent";

@NgModule({
    declarations: [
        SpinnerComponent
    ],
    exports: [
        SpinnerComponent
    ]
})

export class SpinnerComponentModule { }


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Spinner/SpinnerComponentModule.ts